import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Typography, TextareaAutosize, Box, Paper, Button } from "@mui/material";
import { StyledBorderDiv, StyledFlex, StyledSpaceBetween } from "../../Styled";
// import Attherate from "../../assets/images/at-theRate.svg";
import ChatAddBlack from "../../assets/images/chat_add_Black.svg";
// import ChatSend from "../../assets/images/chat_send.svg";
import filesvg from "../../assets/images/chats/file_svg.svg";
import googlesvg from "../../assets/images/chats/google_svg.svg";
import youtubesvg from "../../assets/images/chats/youtube_svg.svg";
import { CLOUD_STORAGE_PROVIDERS } from "../../utils/cloudStorageProviders";
// import exploresvg from "../../assets/images/chats/explore_svg.svg";
import { generateUniqueId } from "../../utils/copytoClipboard";
import Toastbar from "../../common/Toastbar/Toastbar";
import SelectedAttachment from "./MessageComponent/SelectedAttachment.jsx";
import ChatSend from "../../common/SvgImageView/Send.jsx";
import replaym from "../../assets/images/chats/reply.svg";
import { showToastMsg } from "../../appStore/actions/global/action.js";
import LableToolTip from "../../common/LableToolTip.jsx";
import { useTranslation } from "react-i18next";
import useAppSelectors from "../../customHooks/useAppSelectors.jsx";
import { GroupLevelArkchatPermission, MessageType } from "../../utils/constant.js";
import { ActionButton } from "../../common/CustomButtons/CustomButtons.jsx";
import SendToAll from "../../assets/images/sendToAll.svg";
import ChatPrivately from "../../assets/images/chatPrivately.svg";
import AssignTask from "../../assets/images/assignTask.svg";
import RequestApproval from "../../assets/images/requestApproval.svg";
import { fontSizeSchemes } from "../../assets/commonFunction.js";
import session, { replyPreviewText } from "../../utils/helper.js";

const ChatInputControl = ({
  handleclickAttherate,
  newMessages,
  handleMessageSend,
  handleOnChangeNewMessage,
  handleClickYouTube,
  setFileAttachment,
  handleClickGoogle,
  handleClickCloudStorage,
  fileAttachment,
  attachment,
  setisTopicOpen,
  setAttachment,
  replyParentMsg,
  setReplyParentMsg,
  isPrivateChatOn,
  isTaskUpdateOpen,
  setMoveTopicTriggered,
  setPricingDrawerOpen,
  setIsTaskTypeModalOpen,
  isTaskTypeModalOpen,
  selectRecipientsDrawerOpen,
  setMessageType,
  taskAssignedUser,
  isDisableAssignTaskBtn,
  setTaskModalDeatils,
  taskModalDeatils,
  stepper,
  selectedRecipients,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });

  const [isAttachmentMenuOpen, setAttachmentMenuOpen] = useState(false);
  const [isFileSectionDisabled, setFileSectionDisabled] = useState(false);
  const [allAttachment, setAllAttachment] = useState([]);
  const fileRef = useRef(null);
  const menuRef = useRef(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const dispatch = useDispatch();

  const handleAssignTask = (title) => {
    if (newMessages) {
      setIsTaskTypeModalOpen(false);
      let taskObject = {
        title: appContent?.KEY295,
        type: MessageType?.Task,
        subHeader: appContent?.KEY250,
        buttonname: appContent?.KEY295,
        title2: appContent?.KEY295,
        msgType: MessageType?.Task,
      };
      setTaskModalDeatils(taskObject);
      handleclickAttherate(MessageType?.Task);
    }
  };

  const handleRequestApproval = (title) => {
    if (newMessages) {
      let taskObject = {
        title: appContent?.KEY296,
        type: MessageType?.Approval,
        subHeader: appContent?.KEY299,
        buttonname: appContent?.KEY300,
        title2: appContent?.KEY296,
        msgType: MessageType?.Approval,
      };
      setTaskModalDeatils(taskObject);
      setIsTaskTypeModalOpen(false);
      handleclickAttherate(MessageType?.Approval);
    }
  };

  const handleChatPrivately = () => {
    if (newMessages) {
      let taskObject = {
        title: appContent?.KEY301,
        type: MessageType?.Message, // for private chat
        subHeader: appContent?.KEY302,
        buttonname: "",
        msgType: MessageType?.Direct_Mesage,
      };
      setTaskModalDeatils(taskObject);
      setIsTaskTypeModalOpen(false);
      handleclickAttherate(MessageType?.Message); // for private chat
    }
  };

  const handleSendToAll = () => {
    setIsTaskTypeModalOpen(false);
    if (selectedGroup) {
      if (newMessages) {
        handleMessageSend();
      } else {
        setSnackbarMessage(appContent?.KEY328);
        setOpenSnackbar(true);
      }
    }
  };

  const { currentUserData, selectedGroup } = useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen");

  const sendMenuRef = useRef(null);

  const taskTypeModalArray = [
    ...(selectedGroup?.isGroup && isPrivateChatOn
      ? [
        {
          title: appContent?.KEY295,
          icon: AssignTask,
          onClick: () => handleAssignTask(),
        },
      ]
      : []),
    ...(selectedGroup?.isGroup && isPrivateChatOn
      ? [
        {
          title: appContent?.KEY296,
          icon: RequestApproval,
          onClick: () => handleRequestApproval(),
        },
      ]
      : []),
    ...(selectedGroup?.isGroup && isPrivateChatOn
      ? [
        {
          title: appContent?.KEY297,
          icon: ChatPrivately,
          onClick: () => handleChatPrivately(),
        },
      ]
      : []),
    {
      title:
        selectedGroup?.isGroup && isPrivateChatOn
          ? appContent?.KEY298
          : appContent?.KEY64,
      icon: SendToAll,
      onClick: () => handleSendToAll(),
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleCloseAttachmentMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const combinedLength = fileAttachment?.length + attachment?.length;
    const allFilesData = [...fileAttachment, ...attachment];
    setAllAttachment(allFilesData);

    // Setting the disabled state of the checkbox not more than 5 overall attachment
    setFileSectionDisabled(combinedLength === 5);
  }, [fileAttachment, attachment]);
  //
  const handleFileChange = (e) => {
    setAttachmentMenuOpen(false);
    const files = e.target.files; // Get the selected files
    const maxFiles = 5;
    if (files?.length + attachment.length + fileAttachment.length > maxFiles) {
      e.preventDefault();
      dispatch(showToastMsg(`You can only select up to 5 attachment.`));
      return;
    }

    const fileListWithIds = Array.from(files).map((file) => ({
      id: generateUniqueId(file?.name),
      file: file,
    }));

    setFileAttachment([...fileAttachment, ...fileListWithIds]);
  };

  const handlePaste = (e) => {
    const items = e.clipboardData?.items;
    if (!items) return;

    const pastedFiles = [];
    for (const item of items) {
      if (item.kind === "file") {
        const file = item.getAsFile();
        if (file) {
          pastedFiles.push(file);
        }
      }
    }
    if (pastedFiles.length === 0) return;

    e.preventDefault();
    const maxFiles = 5;
    if (
      pastedFiles.length + attachment.length + fileAttachment.length >
      maxFiles
    ) {
      dispatch(showToastMsg(`You can only select up to 5 attachment.`));
      return;
    }

    const fileListWithIds = pastedFiles.map((file, index) => {
      // Clipboard screenshots come in as a generic "image.png"; give
      // them a distinct name. Copied files keep their original name.
      const isClipboardImage =
        file.type.startsWith("image/") &&
        (!file.name || file.name === "image.png");
      const extension = file.type.split("/")[1] || "png";
      const namedFile = isClipboardImage
        ? new File([file], `image-${Date.now()}-${index + 1}.${extension}`, {
          type: file.type,
        })
        : file;
      return {
        id: generateUniqueId(namedFile.name),
        file: namedFile,
      };
    });

    setFileAttachment([...fileAttachment, ...fileListWithIds]);
  };
  const handleAttachmentMenu = () => {
    if (selectedGroup) {
      if (setAttachmentMenuOpen) {
        setAttachmentMenuOpen(!isAttachmentMenuOpen);
      }
    }
  };
  const isDisabledChatSend = () => {
    if (newMessages.trim() === "") return true; // No input, disable send
    if (
      newMessages.trim() &&
      isTaskTypeModalOpen &&
      !selectRecipientsDrawerOpen
    )
      return false; // Modal open, no option selected

    if (
      newMessages.trim() &&
      !isTaskTypeModalOpen &&
      selectRecipientsDrawerOpen &&
      stepper === "datetime"
    )
      return false;
    if (
      newMessages.trim() &&
      !isTaskTypeModalOpen &&
      selectRecipientsDrawerOpen &&
      taskModalDeatils?.type === MessageType?.Message
    ) {
      // For private chat, check if any recipients are selected
      const hasSelectedRecipients =
        selectedRecipients?.selectedInternalRecipients?.length > 0 ||
        selectedRecipients?.selectedExternalRecipients?.length > 0;
      return !hasSelectedRecipients; // Disable if no recipients selected, enable if recipients selected
    } else {
      if (
        newMessages.trim() &&
        !isTaskTypeModalOpen &&
        selectRecipientsDrawerOpen &&
        stepper === "user"
      )
        return true;
    }
    return false; // Otherwise, enabled
  };
  const handleCloseAttachmentMenu = () => {
    setAttachmentMenuOpen(false);
  };

  const handleRemoveAttachment = (attachmentId) => {
    // Remove the file with the specified ID from the state
    const updatedattachment = attachment?.filter(
      (file) => file.id !== attachmentId
    );
    setAttachment(updatedattachment);
    setReplyParentMsg("");
    const updatedFileattachment = fileAttachment?.filter(
      (file) => file.id !== attachmentId
    );
    setFileAttachment(updatedFileattachment);

    setAllAttachment([...updatedFileattachment, ...updatedattachment]);
  };

  //
  const triggerHandelSend = () => {
    if (selectRecipientsDrawerOpen) {
      if (Object.keys(taskAssignedUser).length > 0) {
        if (selectedGroup) {
          if (newMessages) {
            handleMessageSend();
          } else {
            setSnackbarMessage(appContent?.KEY328);
            setOpenSnackbar(true);
          }
        }
      } else {
        if (taskModalDeatils?.type === MessageType?.Message) {
          // for private chat
          if (selectedGroup) {
            if (newMessages) {
              handleMessageSend();
            } else {
              setSnackbarMessage(appContent?.KEY328);
              setOpenSnackbar(true);
            }
          }
        }
      }
    } else {
      if (selectedGroup?.isGroup && isPrivateChatOn) {
        setIsTaskTypeModalOpen(true);
      } else {
        handleMessageSend();
      }
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (sendMenuRef.current && !sendMenuRef.current.contains(event.target)) {
        setIsTaskTypeModalOpen(false);
      }
    }
    if (isTaskTypeModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isTaskTypeModalOpen, setIsTaskTypeModalOpen]);

  return (
    <>
      <Toastbar
        setOpenSnackbar={setOpenSnackbar}
        openSnackbar={openSnackbar}
        snackbarMessage={snackbarMessage}
        severity={"warning"}
      />
      {replyParentMsg && !isTaskUpdateOpen && (
        <Box
          sx={{
            background: "#efefef",
            padding: "8px 10px",
            cursor: "pointer",
            wordWrap: "break-word",
          }}
          display={"flex"}
          alignItems={"center"}
          gap={"0.4rem"}
        >
          <Box>
            <img
              src={replaym}
              alt="reply"
              style={{ width: "18px", height: "12px", flexShrink: 0 }}
            />
          </Box>
          <Typography
            width={"85%"}
            sx={{ wordWrap: "break-word" }}
            fontSize={"0.87rem"}
          >
            {replyPreviewText(replyParentMsg, currentUserData)}
          </Typography>

          <Box position={"absolute"} right={"0.5rem"}>
            <ActionButton
              onClick={() => setReplyParentMsg("")}
              height="25px"
              width="25px"
            >
              X
            </ActionButton>
          </Box>
        </Box>
      )}

      <StyledBorderDiv
        style={{
          position: "relative",
          zIndex: isTaskUpdateOpen ? 1199 : 1201,
          backgroundColor: "#ffff",
        }}
      >
        {((selectedGroup?.isGroup && selectedGroup?.membership) ||
          !selectedGroup?.isGroup) &&
          selectedGroup?.permissionType !==
          GroupLevelArkchatPermission?.REMOVE && (
            <>
              <TextareaAutosize
                minRows={1}
                maxRows={6}
                style={{
                  width: "100%",
                  resize: "vertical",
                  border: "none",
                  outline: "none",
                  lineHeight: "1.25rem",
                  padding: "5px 8px",
                  fontFamily: "Poppins",
                  fontSize: "0.87rem",
                  maxHeight: "25vh",
                }}
                placeholder={appContent?.KEY328}
                disabled={!selectedGroup}
                value={newMessages}
                onChange={handleOnChangeNewMessage}
                onPaste={handlePaste}
              />
              {allAttachment?.length > 0 && !isTaskUpdateOpen && (
                <Box
                  width={"100%"}
                  position={"relative"}
                  height={"3rem"}
                  overflow={"scroll"}
                  sx={{
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                      width: "1px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "transparent",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "transparent",
                    },
                  }}
                >
                  <SelectedAttachment
                    data={allAttachment}
                    handleRemoveAttachment={handleRemoveAttachment}
                    replyParentMsg={replyParentMsg}
                  />
                </Box>
              )}

              <StyledSpaceBetween
                style={{
                  width: "100%",
                  marginBottom: "0.4rem",
                  alignItems: "center",
                }}
              >
                <input
                  type="file"
                  multiple
                  name="file"
                  ref={fileRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <StyledFlex>
                  <Box position={"relative"} width={"30px"} height={"30px"}>
                    {isAttachmentMenuOpen && (
                      <Box
                        ref={menuRef}
                        position="absolute"
                        top={"-15.4rem"}
                        right={"-10.5rem"}
                        width={"12.3rem"}
                      >
                        <Paper
                          sx={{
                            boxShadow:
                              "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;",
                            padding: "0.7rem 0rem",
                          }}
                        >
                          <Box>
                            <Box
                              p={"0.4rem 1rem"}
                              sx={{
                                cursor: "pointer",
                                pointerEvents: isFileSectionDisabled
                                  ? "none"
                                  : "",
                              }}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                onClick={() => fileRef.current.click()}
                              >
                                <Box>
                                  <Typography>Files</Typography>
                                  <span
                                    style={{
                                      display: "block",
                                      fontSize: "0.65rem",
                                    }}
                                  >
                                    {appContent?.KEY226}
                                  </span>
                                </Box>
                                <Box>
                                  <img src={filesvg} alt="file" />
                                </Box>
                              </Box>
                            </Box>

                            {CLOUD_STORAGE_PROVIDERS.map((provider) => (
                              <Box
                                key={provider.id}
                                mt={"0.7rem"}
                                p={"0.4rem 1rem"}
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleCloseAttachmentMenu();
                                  handleClickCloudStorage(provider.id);
                                }}
                              >
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <Typography>{provider.label}</Typography>
                                  </Box>
                                  <Box>
                                    <img
                                      src={provider.icon}
                                      alt={provider.label}
                                      width={16}
                                      height={16}
                                    />
                                  </Box>
                                </Box>
                              </Box>
                            ))}

                            <Box
                              mt={"0.7rem"}
                              p={"0.4rem 1rem"}
                              sx={{ cursor: "pointer" }}
                              onClick={handleClickGoogle}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Box>
                                  <Typography>Google</Typography>
                                </Box>
                                <Box>
                                  <img src={googlesvg} alt="file" />
                                </Box>
                              </Box>
                            </Box>

                            <Box
                              mt={"0.7rem"}
                              p={"0.4rem 1rem"}
                              sx={{ cursor: "pointer" }}
                              onClick={handleClickYouTube}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Box>
                                  <Typography>Youtube</Typography>
                                </Box>
                                <Box>
                                  <img src={youtubesvg} alt="file" />
                                </Box>
                              </Box>
                            </Box>

                            {/* <Box
                            mt={"0.7rem"}
                            p={"0.4rem 1rem"}
                            sx={{ cursor: "pointer" }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Box>
                                <Typography>Arkchat Explore</Typography>
                              </Box>
                              <Box>
                                <img src={exploresvg} alt="file" />
                              </Box>
                            </Box>
                          </Box> */}
                          </Box>
                        </Paper>
                      </Box>
                    )}
                    <LableToolTip title={appContent?.KEY256}>
                      <img
                        className="chat-input-icon"
                        src={ChatAddBlack}
                        alt="attachment"
                        onClick={handleAttachmentMenu}
                      />
                    </LableToolTip>
                  </Box>
                  {/* <img
              style={{ display: "none" }}
              className="chat-input-icon"
              src={ChatVideo}
              alt="video"
            /> */}

                  {/* <img className="chat-input-icon" src={ChatMic} alt="mic" /> */}
                  {newMessages.trim() && (
                    <>
                      {selectedGroup?.isGroup &&
                        isPrivateChatOn &&
                        !isThreadScreen && (
                          <>
                            {/* <Box
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"flex-end"}
                            ml={"0.4rem"}
                            maxWidth={"100%"}
                          >
                            <Box
                              display={"flex"}
                              alignItems={"center"}
                              gap={"0.5rem"}
                              justifyContent={"center"}
                            >
                              <Box>
                                <Typography
                                  variant="h5"
                                  fontSize={"0.7rem"}
                                  color={"#00000"}
                                  fontWeight={600}
                                  mr={"0.5rem"}
                                  title={`Topic : ${
                                    selectedTopicToSaveMsg
                                      ? selectedTopicToSaveMsg.name
                                      : "General"
                                  }`}
                                >
                                  {`Topic : ${
                                    selectedTopicToSaveMsg
                                      ? selectedTopicToSaveMsg.name.slice(
                                          0,
                                          20
                                        ) +
                                        (selectedTopicToSaveMsg.name?.length >
                                        20
                                          ? " ..."
                                          : "")
                                      : "General"
                                  }`}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              onClick={() => {
                                setisTopicOpen(true);
                                setMoveTopicTriggered(false);
                                dispatch(handleChangeTopicOpen(true));
                              }}
                              sx={{ cursor: "pointer" }}
                            >
                              <Typography
                                variant="h5"
                                color={"#DB0011"}
                                fontSize={"0.7rem"}
                                fontWeight={600}
                              >
                                Change
                              </Typography>
                            </Box>
                          </Box> */}
                          </>
                        )}
                    </>
                  )}
                </StyledFlex>

                {newMessages.trim() && (
                  <StyledFlex>
                    {selectedGroup?.isGroup && isPrivateChatOn && (
                      <LableToolTip title={appContent?.KEY257}>
                        {/* <Box
                          className="chat-input-left-icon"
                          onClick={newMessages ? handleclickAttherate : undefined}
                          border={"1px solid"}
                          display={"flex"}
                          alignItems={"center"}
                          gap={"0.25rem"}
                          padding={"0rem 0.4rem"}
                          borderRadius={"0.2rem"}
                        >
                          <Typography variant="h5" fontSize={"0.7rem"}>
                            Task & Private message
                          </Typography>
                          <Attherate
                            color={newMessages.trim() ? null : "#A2A2A2"}
                          />
                        </Box>
                    */}
                      </LableToolTip>
                    )}
                    <LableToolTip title={appContent?.KEY258}>
                      <Box
                        className="chat-input-left-icon"
                        onClick={() => {
                          if (isDisabledChatSend()) {
                            return null;
                          } else {
                            triggerHandelSend();
                          }
                        }}
                        ref={sendMenuRef}
                      >
                        <ChatSend
                          color={isDisabledChatSend() ? "#8C8C8C" : null}
                        />
                      </Box>
                    </LableToolTip>
                  </StyledFlex>
                )}
              </StyledSpaceBetween>
            </>
          )}
        {selectedGroup &&
          !selectedGroup?.membership &&
          selectedGroup?.isGroup &&
          selectedGroup?.permissionType !==
          GroupLevelArkchatPermission?.REMOVE && (
            <>
              {currentUserData?.accountOwner ? (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  padding="1rem 1rem"
                >
                  <Button
                    onClick={() => setPricingDrawerOpen(true)}
                    sx={{
                      background: "#FFFFFF",
                      color: "black",
                      borderRadius: "4px",
                      border: "1px solid black",
                      fontSize: "0.75rem",
                      textTransform: "none",
                      "&:hover": {
                        background: "#f3f3f3",
                        color: "black",
                      },
                    }}
                  // variant="contained"
                  >
                    Buy Subscription
                  </Button>
                </Box>
              ) : (
                <Box
                  bgcolor={"#F3F3F3"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  padding="1rem 1rem"
                >
                  <Typography fontSize="0.87rem" textAlign={"center"}>
                    Your account no longer has an active subscription. <br />Please
                    contact your Arkchat account owner to renew it to
                    reactivate group chats.
                  </Typography>
                </Box>
              )}
            </>
          )}
        {selectedGroup &&
          selectedGroup?.isGroup &&
          selectedGroup?.permissionType ===
          GroupLevelArkchatPermission?.REMOVE && (
            <Box bgcolor={"#F3F3F3"} padding={"2.5rem"} textAlign={"center"}>
              <Typography>You are no longer a member of this group.</Typography>
            </Box>
          )}
      </StyledBorderDiv>
      {isTaskTypeModalOpen && (
        <Box
          position="absolute"
          bottom="2.5rem"
          right="0"
          zIndex={1300}
          ref={sendMenuRef}
          onClick={(e) => e.stopPropagation()}
        >
          <Paper sx={{ p: 2, minWidth: 200 }}>
            <Box display="flex" flexDirection="column" gap={2}>
              {taskTypeModalArray.map((item, index) => (
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  sx={{ cursor: "pointer" }}
                  key={index}
                  onClick={() => item.onClick(item.title)}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    width={16}
                    height={16}
                  />
                  <Typography
                    fontSize={fontSizeSchemes.font16}
                    fontWeight={400}
                    sx={{
                      flex: 1,
                      textAlign: "left",
                      paddingTop: "0.3rem",
                      paddingBottom: "0.3rem",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Box>
      )}
    </>
  );
};
export default ChatInputControl;
